// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { React } from 'react'
import {
  Route,
  Routes,
  useNavigate,
  Navigate,
  useLocation
} from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { checkGotoChooseAccount } from '../../utils/common-utils'
import { AUTHZContextProvider } from '../../context/authz-context'
import { isServiceCentric } from '../../utils/account-utils'
import { isGLOP } from '../../utils/feature-flag-utils'

import GetStartedRouter from './get-started-videos/router'
import { VideosTutorials } from './videos-tutorials'
import Home from './home'
import HomePreServiceCentric from './home-pre-service-centric'

const HomeRouterContent = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const LDFlags = useFlags()
  checkGotoChooseAccount(navigate, location)
  const serviceCentric = isServiceCentric(LDFlags) || isGLOP()
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={serviceCentric ? <Home /> : <HomePreServiceCentric />}
      />
      <Route path="/get-started" element={<GetStartedRouter />} />
      <Route path="/videos-tutorials" element={<VideosTutorials />} />
      <Route path="/*" element={<Navigate to="/not-found" />} />
    </Routes>
  )
}

const HomeRouter = () => {
  return (
    <AUTHZContextProvider>
      <HomeRouterContent />
    </AUTHZContextProvider>
  )
}

export default HomeRouter
